import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Chart } from 'angular-highcharts';
import * as Highcharts from 'highcharts';

declare var require: any
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);
require('highcharts/modules/annotations')(Highcharts);

interface DatoDataArea{
  fecha_hora: string | Date;
  valor     : number;
}

@Component({
  selector: 'app-lfsa-gh-area',
  templateUrl: './lfsa-gh-area.component.html',
  styleUrls: ['./lfsa-gh-area.component.css']
})

export class LfsaGhAreaComponent implements OnChanges {
  @Input() data   : DatoDataArea[] = [];
  @Input() titulo : string = 'Historico pesaje por Línea';
  
  constructor() {}

  //chart?: Chart;
  chart: Chart;

  ngOnChanges(changes: SimpleChanges){
    console.log("ngOnChanges", this.data);
    if (changes['data'] && this.data && this.data.length > 0) {
      console.log("llegaron los datos", this.data);
      this.generarGrafico();
    }
  }

  generarGrafico() {
    console.log("datos grafico 2", this.data);

    this.chart = new Chart({
      chart: {
        type: 'areaspline',
        backgroundColor: '#ffffff',
        height: 300,
        zoomType: 'x',
      },
      time: { useUTC: false },
      title: {text: this.titulo},
      xAxis: {
        type: 'datetime',
        title: { text: 'Hora' },
        dateTimeLabelFormats: { hour: '%H:%M', minute: '%H:%M:%S' },
      },
      yAxis: {
        title: { text: 'Pesos' },
      },
      tooltip: {
        xDateFormat: '%H:%M',
        valueSuffix: ' °G',
        shared: true,
      },
      series: [
        {
          type: 'areaspline',
          name: 'Pesos',
          data: this.data.map(d => [
            new Date(d.fecha_hora).getTime(), 
            Number(d.valor), 
          ]),
          color: '#00B050',
          fillOpacity: 0.25,
          lineWidth: 3,
          marker: { enabled: true, radius: 3 },
        },
      ],
      credits: { enabled: false },
    });

  }

}
